import React from 'react';
import styled from 'styled-components/macro';

import { ReactComponent as overview } from 'icons/navigation-icons/overview.svg';
import { ReactComponent as audience } from 'icons/navigation-icons/audience.svg';
import { ReactComponent as performance } from 'icons/navigation-icons/dsp-activity.svg';
import { ReactComponent as charts } from 'icons/navigation-icons/chart-position.svg';
import { ReactComponent as airplay } from 'icons/navigation-icons/radio-shazam.svg';
import { ReactComponent as social } from 'icons/navigation-icons/social.svg';
interface INavIconProps {
  navElementName: string;
}

const StyledIcon = styled.svg`
  max-height: 17px;
`;

const NavIcon: React.FC<INavIconProps> = (props) => {
  const { navElementName } = props;

  const icons: any = {
    overview,
    audience,
    performance,
    charts,
    airplay,
    social,
  };

  const hasNoIcon = navElementName in icons === false;

  if (hasNoIcon) return null;
  return <StyledIcon as={icons[navElementName]} />;
};

export default NavIcon;
